export default __webpack_public_path__ + "static/logo_footer-6dc02dd970ef0bc89c30699f9ff16ce0.png";